import { NavItem } from 'src/common/NavBar/TopLevelNavItemContext';

export const rideOrderingPortalTabs: NavItem[] = [
  { name: 'Accounts', href: '/team' },
];
